import React from 'react';


const Step2c = (props) => {

    return (
        <div id="step-2c" className="question-step">
            <div className="step-title_container">

                <div className="col-11 col-md-10">
                    <h2 className="question-title">Almost done, we told you it wouldn’t take long.</h2>
                    <hr className="question-title_line"/>
                    <p className="question-text">Your yearly income before taxes, alimony, child support, or separate
                        maintenance is optional and does not need to be included if you do not wish it to be considered
                        as a basis for repaying the loan. Increase any non-taxable income by 25%.</p>
                </div>

                <div className="step-2_form clearfix">
                    {
                        props.questions.map((q, i) => {
                            if (i >= props.start && i <= props.end) {
                                return props.renderQuestion(q, i)
                            }

                        })
                    }
                </div>
                <div className="col-11 col-md-10">
                    <p className="question-text pt-4">The next step is a soft credit pull. Don't worry, this is a normal
                        part of the process and won't lower your score at all. It just helps us figure out your
                        general price range. Your information is transmitted using the industry standard 256-bit
                        encryption to ensure security. </p>
                </div>
                <div className="step-2_form clearfix">
                    {
                        props.questions.map((q, i) => {
                            if (i >= props.startB && i <= props.endB) {
                                return props.renderQuestion(q, i)
                            }

                        })
                    }
                </div>
            </div>

        </div>
    )
}

export default Step2c;
